module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon-120x120.d60a3a4e923537cab2d824179d9902d3.png";